import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import PropTypes from 'prop-types';
import Screens from '..';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import { API_ROOT_LIST } from '../../api/Constants';
import { casinoIdStatus } from '../../api/PlayerInfoConstants';
import PlayerInterface from '../../api/PlayerInterface';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import SettingsTitleEnum from './SettingsTitleEnum';
import SettingsScreensEnum from './SettingsScreensEnum';
import audio from '../../utils/audio';
import useFeatureFlags from '../../hooks/useFeatureFlags';
import { FE_LINK_GUEST_LOGIN } from '../../utils/featureFlags/constants';
import { AUTH_TYPES } from '../../utils/authFlow/constants';
import InboxMessagesProvider from '../../components/InboxMessagesProvider';
import NotificationContext from '../../context/NotificationContext';
import { getText, TEXT_KEY } from '../../utils/localization';

var Settings = /*#__PURE__*/function (_Component) {
  _inherits(Settings, _Component);

  var _super = _createSuper(Settings);

  function Settings(props) {
    var _this;

    _classCallCheck(this, Settings);

    _this = _super.call(this, props);
    _this.initPlayerSettingsInfo = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$PlayerInterfac, casinoId, email, emailOptIn, name;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return PlayerInterface.getPlayerProfile();

            case 3:
              _yield$PlayerInterfac = _context.sent;
              casinoId = _yield$PlayerInterfac.casinoId;
              email = _yield$PlayerInterfac.email;
              emailOptIn = _yield$PlayerInterfac.emailOptIn;
              name = _yield$PlayerInterfac.name;

              _this.setState({
                playerName: name,
                casinoId: casinoId,
                email: email,
                emailOptIn: emailOptIn
              });

              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              console.log('getPlayerProfileResponse Error: ', _context.t0);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 11]]);
    }));

    _this._changeComponentHandler = function (settingsScreen) {
      _this.setState({
        settingsScreen: settingsScreen,
        showPopUp: false,
        popUpTitle: ''
      });
    };

    _this._onChangeComponentHandler = function (nextScreen) {
      audio.onClick();
      var history = Array.from(_this.state.history);
      history.push(nextScreen);

      _this.setState({
        settingsScreen: nextScreen,
        history: history,
        showPopUp: false,
        popUpTitle: ''
      });
    };

    _this._goBackHandler = function () {
      audio.onClick();
      var history = Array.from(_this.state.history);
      history.pop();
      var index = history.length - 1;
      var nextScreen = index > -1 && history[index] || SettingsScreensEnum.settings;

      _this.setState({
        settingsScreen: nextScreen,
        history: history,
        showPopUp: false,
        popUpTitle: ''
      });
    };

    _this._onShowPopUp = function (popUpTitle) {
      _this.setState({
        showPopUp: true,
        popUpTitle: popUpTitle
      });
    };

    _this._toggleSound = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props, soundEffects, setSoundSettings, music, toggleSoundResponse, eventPayload;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              audio.onClick();
              _this$props = _this.props, soundEffects = _this$props.soundEffects, setSoundSettings = _this$props.setSoundSettings, music = _this$props.music;
              _context2.prev = 2;
              _context2.next = 5;
              return PlayerInterface.toggleSound();

            case 5:
              toggleSoundResponse = _context2.sent;

              if (toggleSoundResponse) {
                eventPayload = {
                  status: !soundEffects ? 1 : 0
                };
                Logger.sendEvent(EVENT_TYPES.SETTING_SOUND_EFFECTS_TOGGLE, eventPayload);
                setSoundSettings({
                  soundEffects: !soundEffects,
                  music: music
                });
              }

              audio.onClick();
              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](2);
              console.log('toggleSoundResponse Error: ', _context2.t0);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 10]]);
    }));
    _this._toggleMusic = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _this$props2, soundEffects, setSoundSettings, music, toggleMusicResponse, eventPayload;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              audio.onClick();
              _this$props2 = _this.props, soundEffects = _this$props2.soundEffects, setSoundSettings = _this$props2.setSoundSettings, music = _this$props2.music;
              _context3.prev = 2;
              _context3.next = 5;
              return PlayerInterface.toggleMusic();

            case 5:
              toggleMusicResponse = _context3.sent;

              if (toggleMusicResponse) {
                eventPayload = {
                  status: !music ? 1 : 0
                };
                Logger.sendEvent(EVENT_TYPES.SETTING_AMBIENT_SOUND_TOGGLE, eventPayload);
                setSoundSettings({
                  soundEffects: soundEffects,
                  music: !music
                });
              }

              audio.playMusic('backgroundMusic');
              audio.onClick();
              _context3.next = 14;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](2);
              console.log('toggleMusicResponse Error: ', _context3.t0);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 11]]);
    }));
    _this._toggleEmailOptIn = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var emailOptIn, params, updatePlayerProfileResponse, eventPayload;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              audio.onClick();
              emailOptIn = _this.state.emailOptIn;
              _context4.prev = 2;
              params = {
                emailOptIn: !emailOptIn ? 'yes' : 'no'
              };
              _context4.next = 6;
              return PlayerInterface.updatePlayerProfile(params);

            case 6:
              updatePlayerProfileResponse = _context4.sent;

              if (updatePlayerProfileResponse.success) {
                eventPayload = {
                  status: !emailOptIn
                };
                Logger.sendEvent(EVENT_TYPES.SETTINGS_PROMO_EMAIL_TOGGLE, eventPayload);

                _this.setState({
                  emailOptIn: !emailOptIn
                });
              }

              _context4.next = 13;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](2);
              console.log('updatePlayerProfileResponse Error: ', _context4.t0);

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 10]]);
    }));
    _this._logoutHandler = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var platformLogout;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              audio.onClick();
              platformLogout = _this.props.platformLogout;
              platformLogout(_this._sharedLogout, _this.props.casinoIdStatus);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    _this._sharedLogout = function () {
      audio.pauseMusic();
      var _this$props3 = _this.props,
          clearToken = _this$props3.clearToken,
          navigation = _this$props3.navigation,
          setLastPromoCode = _this$props3.setLastPromoCode,
          clearOnboarding = _this$props3.clearOnboarding,
          clearAssets = _this$props3.clearAssets,
          clearPrePurchaseStore = _this$props3.clearPrePurchaseStore,
          clearSavedGameInfo = _this$props3.clearSavedGameInfo,
          cleanMissions = _this$props3.cleanMissions,
          clearActionCommands = _this$props3.clearActionCommands;
      clearToken();
      setLastPromoCode(null);
      clearPrePurchaseStore();
      clearSavedGameInfo();
      clearOnboarding();
      clearAssets();
      cleanMissions();
      clearActionCommands();
      InboxMessagesProvider.resetInbox();
      QueryParamsProxy.setQueryParams({
        m: undefined
      });
      QueryParamsProxy.navigate(navigation, Screens.Start);
    };

    _this._handleCheatMenuClick = function () {
      audio.onClick();
      QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.CheatMenu));
    };

    _this._setApiRoot = function (newRoot) {
      var setApiRootIndex = _this.props.setApiRootIndex;
      setApiRootIndex(newRoot);

      _this.context.addNotification({
        message: getText(TEXT_KEY.ENV_CHANGED),
        button: getText(TEXT_KEY.OK)
      });

      _this._sharedLogout();
    };

    _this.state = {
      settingsScreen: SettingsScreensEnum.settings,
      history: [SettingsScreensEnum.settings],
      casinoId: null,
      email: null,
      emailOptIn: false,
      playerName: null,
      showPopUp: false,
      popUpTitle: ''
    };
    _this.state.settingsScreen = QueryParamsProxy.findParam(RouteParamConstants.PARAM_SETTINGS_SCREEN, SettingsScreensEnum.settings);
    return _this;
  }

  _createClass(Settings, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initPlayerSettingsInfo();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setModal(null);
    }
  }, {
    key: "render",
    value: function render() {
      var _useFeatureFlags = useFeatureFlags(),
          hasFeature = _useFeatureFlags.hasFeature;

      var isLinkGuestAccountEnabled = hasFeature(FE_LINK_GUEST_LOGIN);
      var _this$state = this.state,
          playerName = _this$state.playerName,
          casinoId = _this$state.casinoId,
          email = _this$state.email,
          emailOptIn = _this$state.emailOptIn,
          settingsScreen = _this$state.settingsScreen,
          prevScreen = _this$state.prevScreen,
          environment = _this$state.environment;
      var _this$props4 = this.props,
          playerId = _this$props4.playerId,
          propsCasinoIdStatus = _this$props4.casinoIdStatus,
          propertyName = _this$props4.propertyName,
          isDevUser = _this$props4.isDevUser,
          soundEffects = _this$props4.soundEffects,
          music = _this$props4.music,
          apiRootIndex = _this$props4.apiRootIndex,
          formInfo = _this$props4.formInfo,
          setFormInfo = _this$props4.setFormInfo,
          render = _this$props4.render,
          lastLoginInfo = _this$props4.lastLoginInfo,
          _this$props4$assetsUr = _this$props4.assetsUrls,
          termsAndConditions = _this$props4$assetsUr.termsAndConditions,
          privacyPolicy = _this$props4$assetsUr.privacyPolicy;
      var showCheatMenu = isDevUser;
      var isGuest = propsCasinoIdStatus === casinoIdStatus.GUEST || (lastLoginInfo === null || lastLoginInfo === void 0 ? void 0 : lastLoginInfo.loginMethod) === AUTH_TYPES.GUEST;
      return render({
        playerId: playerId,
        verifiedAccount: propsCasinoIdStatus === casinoIdStatus.PHYSICALLY_VERIFIED || propsCasinoIdStatus === casinoIdStatus.DIGITALLY_VERIFIED,
        isGuest: isGuest,
        playerName: playerName,
        casinoId: casinoId,
        email: email,
        emailOptIn: emailOptIn,
        propertyName: propertyName,
        soundEffects: soundEffects,
        music: music,
        logoutHandle: this._logoutHandler,
        toggleSound: this._toggleSound,
        toggleMusic: this._toggleMusic,
        toggleEmailOptIn: this._toggleEmailOptIn,
        changeComponentHandler: this._changeComponentHandler,
        onChangeComponentHandler: this._onChangeComponentHandler,
        goBackHandler: this._goBackHandler,
        clearUserData: this._sharedLogout,
        settingsScreen: settingsScreen,
        prevScreen: prevScreen,
        apiRootList: API_ROOT_LIST,
        apiRootIndex: apiRootIndex,
        setApiRootIndex: this._setApiRoot,
        formInfo: formInfo,
        setFormInfo: setFormInfo,
        propsCasinoIdStatus: propsCasinoIdStatus,
        titleEnum: SettingsTitleEnum(),
        screensEnum: SettingsScreensEnum,
        onShowPopUp: this._onShowPopUp,
        showPopUp: this.state.showPopUp,
        popUpTitle: this.state.popUpTitle,
        showCheatMenu: showCheatMenu,
        onClickCheatMenu: this._handleCheatMenuClick,
        privacyPolicy: privacyPolicy,
        termsAndConditions: termsAndConditions,
        environment: environment,
        lastLoginInfo: lastLoginInfo,
        isLinkGuestAccountEnabled: isLinkGuestAccountEnabled
      });
    }
  }]);

  return Settings;
}(Component);

Settings.contextType = NotificationContext;
export { Settings as default };
Settings.propTypes = {
  soundEffects: PropTypes.any.isRequired,
  setSoundSettings: PropTypes.any.isRequired,
  music: PropTypes.any.isRequired,
  clearToken: PropTypes.any.isRequired,
  navigation: PropTypes.any.isRequired,
  platformLogout: PropTypes.any.isRequired,
  setApiRootIndex: PropTypes.any,
  render: PropTypes.any.isRequired,
  playerId: PropTypes.any.isRequired,
  casinoIdStatus: PropTypes.any.isRequired,
  propertyName: PropTypes.any.isRequired,
  apiRootIndex: PropTypes.any.isRequired,
  formInfo: PropTypes.any.isRequired,
  setFormInfo: PropTypes.any.isRequired
};